import { Form, redirect } from "react-router-dom";
import { useState } from "react";

import SalesStepOne from "./SalesStepOne";
import SalesStepTwo from "./SalesStepTwo";
import SalesStepThree from "./SalesStepThree";
import { API_BASE_URL } from "../../../config.js";
import { getAuthToken } from "../../../auth/auth.js";

export default function SalesEngineer() {
  const [handleNum, setHandleNum] = useState(0);
  const [allResults, setAllResults] = useState([]);

  const handleIncrementStep = () => {
    setHandleNum((prevState) => prevState + 1);
  };

  const handleDecrementStep = () => {
    setHandleNum((prevState) => prevState - 1);
  };

  const handleSkillResults = (value) => {
    setAllResults(value);
  };

  const steps = [
    {
      component: (
        <SalesStepOne
          num={handleNum + 1}
          handleIncrement={handleIncrementStep}
        />
      ),
    },
    {
      component: (
        <SalesStepTwo
          num={handleNum + 1}
          handleIncrement={handleIncrementStep}
          handleDecrement={handleDecrementStep}
          handleResults={handleSkillResults}
        />
      ),
    },
    {
      component: (
        <SalesStepThree
          num={handleNum + 1}
          handleDecrement={handleDecrementStep}
        />
      ),
    },
  ];

  return (
    <>
      <div className="select-role-wrapper-div sales-role-wrapper-div">
        <Form method="post" encType="multipart/form-data">
          <input
            type="hidden"
            value={JSON.stringify(allResults)}
            name="job_type_categories"
          />
          <div className="select-rol-current-step">
            {steps.map((step, index) => (
              <div
                key={index}
                style={{ display: handleNum === index ? "block" : "none" }}
              >
                {step.component}
              </div>
            ))}
          </div>
        </Form>
      </div>
    </>
  );
}

export async function salesEngineerAction({ request }) {
  const formData = await request.formData();

  const token = getAuthToken();

  const data = new FormData();

  data.append("current_role", formData.get("current_role"));
  data.append("phone", formData.get("phone"));
  data.append("linkedin", formData.get("linkedin_url"));

  const avatarFile = formData.get("profile_image");
  if (avatarFile instanceof File) {
    data.append("avatar", avatarFile);
  }

  const jobTypes = formData.get("job_types").split(",").map(Number);

  jobTypes.forEach((id) => {
    data.append("job_types[]", id);
  });

  const skillsFromHidden = JSON.parse(formData.get("job_type_categories"));

  skillsFromHidden.forEach((skillId) => {
    data.append("skills[]", skillId);
  });

  formData.getAll("ideal_companies").forEach((company) => {
    data.append("ideal_companies[]", company);
  });

  formData.getAll("other_companies").forEach((company) => {
    data.append("other_companies[]", company);
  });

  const response = await fetch(`${API_BASE_URL}/employee/approval`, {
    method: "POST",
    body: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const result = await response.json();

  if (result.success === true) {
    const id = localStorage.getItem("id");

    // localStorage.setItem("avatar", result.avatar);
    localStorage.setItem("approved", 2);
    return redirect(`/my-profile/${id}`);
  }
}
